import { z } from 'zod';
import { ZoneSchema } from '../Zones/types';

export const MapSchema = z.object({
    created: z.string().describe('2023-11-27 21:51:02'),
    name: z.string(),
    creator_id: z.number(),
    // schedule: z.object({
    //     when: z.string()
    // }),
    id: z.number(),
});
export type MapType = z.infer<typeof MapSchema>;

export const MapCreateSchema = z.object({
    name: z.string(),
    schedule: z
        .object({
            when: z.string(),
        })
        .optional(),
});
export type MapCreateType = z.infer<typeof MapCreateSchema>;

export const MapUpdateDataSchema = z.object({
    properties: z.object({
        name: z.string(),
    }),
    zones: z.array(
        ZoneSchema.omit({ created: true, map_id: true })
        // z.object({
        //     id: z.number().nullable(),
        //     name: z.string(),
        //     vehicle_id: z.number().nullable(),
        //     color: z.string().regex(/^#[0-9a-f]{6}$/i),
        //     order: z.number().catch(0),
        //     geom: z.object({
        //         type: z.string().regex(/^Polygon$/),
        //         coordinates: z.array(z.array(z.array(z.number()))),
        //     }),
        // })
    ),
});
export type MapUpdateDataType = z.infer<typeof MapUpdateDataSchema>;
